module.exports = __webpack_public_path__ + "static/img/table.fe7671a5.svg";